import {useCallback, useEffect} from "react"
import { batch } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"
import { useValidatorSeeker } from "@app"
import { useToast } from "@hooks"
import {
	acriss,
	acrissCategory,
	analyzerDate,
	categories,
	currency,
	directSiteBrokerProvider,
	fuelPolicy,
	includeProviders,
	insurance,
	inTerminal,
	mainProvider,
	mainSite,
	mileage,
	offices,
	prepaid,
	priceKpi,
	providers,
	reports,
	searchID,
	singleDate,
	singleDateFormated,
	sites,
	transmission
} from "@signals"
import { brokersSchema } from "Pages/AnalyzersV2/Brokers/schema"
import { analyzerFilters, isAnalyzerLoading, resetSignals, responseData, tableHasMainComparison, tableTabSelected } from "Pages/AnalyzersV2/@signals"
import { brokersPayload } from "Pages/AnalyzersV2/Brokers/@signals"
import { SECTIONS } from "Pages/AnalyzersV2/@constants"


export default function useAnalyzerBrokersFilters() {
	const { showToast } = useToast()

	const { isValid, errors } = useValidatorSeeker({
		currency: currency.value,
		officePickupID: offices.value,
		groupByAcriss: acrissCategory.value,
		dates: analyzerDate.value,
		...!Array.isArray(sites.value) && { sites: sites.value },
		acriss: acriss.value,
		mainSite: mainSite.value,
		directSiteBrokerProvider: directSiteBrokerProvider.value
	}, brokersSchema(searchID.value))

	const onSubmit = useCallback((clearTab = false) => batch(() => {
		isAnalyzerLoading.value = true
		responseData.value = {}
		resetSignals(clearTab)
		tableHasMainComparison.value = !!mainSite.value || !!mainProvider.value
		postSubmit("/api/dashboard/results", brokersPayload.value).then(res => {
			batch(() => {
				responseData.value = { ...res, type: SECTIONS.BROKERS }
				analyzerFilters.value = res.filters
				isAnalyzerLoading.value = false
			})
		}).catch(() => {
			showToast.error()
			isAnalyzerLoading.value = false
		})
	}), [
		includeProviders.value, singleDateFormated.value, providers.value,
		currency.value, offices.value, tableTabSelected.value, acriss.value,
		transmission.value, categories.value, fuelPolicy.value, providers.value,
		prepaid.value, mileage.value, priceKpi.value, inTerminal.value, insurance.value,
		includeProviders.value, sites.value, reports.value, isValid, singleDate.value
	])

	return {
		onSubmit,
		isValid: !!sites.value && ((isValid && !!reports.value) || !!searchID.value),
		errors: errors
	}
}